import { useCallback, useEffect, useRef, useState } from 'react'

export function useMobileMenu(pathname: string, isMobile: boolean) {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false)
  const prevPathnameRef = useRef<string | null>(null)
  const prevIsMobileRef = useRef<boolean | null>(null)

  const handleToggle = useCallback(() => {
    if (isMobile) {
      setIsMobileMenuOpen((prev) => !prev)
    }
  }, [isMobile])

  const handleClose = useCallback(() => {
    setIsMobileMenuOpen(false)
  }, [])

  useEffect(() => {
    const pathnameChanged = prevPathnameRef.current !== null && prevPathnameRef.current !== pathname
    const isMobileChanged = prevIsMobileRef.current !== null && prevIsMobileRef.current !== isMobile

    prevPathnameRef.current = pathname
    prevIsMobileRef.current = isMobile

    if (pathnameChanged || isMobileChanged) {
      setIsMobileMenuOpen(false)
    }

    return undefined
  }, [pathname, isMobile])

  return { isMobileMenuOpen, handleToggle, handleClose }
}
